import React from "react";
import { List, ListItem, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { PreviousApplicationDto } from "../../../types/projectTypes";

/**
 * Props for the PreviousProjectAppications component
 */
interface PreviousProjectAppicationsProps {
  memberId: number;
  previousApplications: PreviousApplicationDto[];
}

/**
 * Displays the previous applications of a member
 * @param memberId - The id of the member
 * @returns The previous applications of the member
 */
const PreviousProjectAppications: React.FC<PreviousProjectAppicationsProps> = ({ memberId, previousApplications }) => {
  if (previousApplications.length === 0) {
    return <Typography>Das Mitglied hat sich bisher noch nicht für ein Projekt beworben</Typography>;
  }
  return (
    <List sx={{ listStyleType: "square", pl: 2, flex: 3 }} disablePadding dense>
      {previousApplications.map((application) => (
        <ListItem key={application.projectId} sx={{ display: "list-item" }} disablePadding>
          <Link
            to={`/projekte/${application.projectId}/projektbewerbungen/${memberId}`}
            style={{ color: "inherit", textDecoration: "none" }}
          >
            {application.projectName} (
            {application.type === "Bewerbung" ? "Bewerbung war nicht erfolgreich" : application.type})
          </Link>
        </ListItem>
      ))}
    </List>
  );
};

export default PreviousProjectAppications;
